export const media = {
    type: 'media',
    contentType: 'medium',
    title: 'Media',
    plural: 'Media',
    endpoint: 'media',
    gridSupportContent: [],
    listing: {
        type: 'media',
    },
    queryProperties: ['id', 'path', 'title', 'alt', 'size', 'description', 'type', 'created'],
    sidebar: {},
    meta: [],
    validate: [],
};
//# sourceMappingURL=media.js.map